module.exports = __webpack_public_path__ + "img/eagleWingsLogo@2x.0888a0d4.webp";